<template>
  <div id="content" class="crpg-o-private-helicopter-content">

    <div class="crpg-o-private-helicopter-content__pic-1">
      <img
        :src="require('@/assets/img/privateHelicopter/pic_1.png')"
        alt=""
      />
      <h1>{{ $t("privateHelicopter.helicopters") }}</h1>
      <div class="info">

        <div class="caption">{{ $t("privateHelicopter.photo") }}</div>
        <div>
          <div class="orange">{{ $t("privateHelicopter.rent") }}</div>
          <div class="text">{{ $t("privateHelicopter.reduceTime") }}<br>
            {{ $t("privateHelicopter.bestOffer") }}</div>
        </div>
      </div>
    </div>

    <div class="frame">
      <div class="frame__inner">
        <h3>{{ $t("privateHelicopter.benefits") }}</h3>
        <p>{{ $t("privateHelicopter.members") }}<br>{{ $t("privateHelicopter.greatIsland") }}</p>
        <div class="present">{{ $t("privateHelicopter.gift") }}</div>
        <div class="note">{{ $t("privateHelicopter.arrivalDepart") }}</div>
      </div>
    </div>

    <div class="crpg-o-private-helicopter-content__table">
      <h3>{{ content[0].title }}</h3>
      <table>
        <tbody>
        <tr v-for="(tr, i) in content[0].content" :key="i">
          <th>{{ tr.th }}</th>
          <td>
            <div v-for="(line, j) in tr.td" :key="j">
              {{ line }}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="crpg-o-private-helicopter-content__table">
      <h3>{{ content[1].title }}</h3>
      <table>
        <tbody>
        <tr v-for="(tr, i) in content[1].content" :key="i">
          <th>{{tr.th}}</th>
          <td v-for="(td, j) in tr.td" :key="j">{{ td }}</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import text from "@/assets/txt/private_helicopter.json";

var obj = text;

export default {
  name: "PrivateHelicopterContent",

  data() {
    return {
      content: obj.tables,
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/templates/privateHelicopter.scss";
</style>
